import { ChevronDownIcon } from '@heroicons/react/16/solid';
import {
  Button,
  EllipsisMenu,
  EllipsisMenuItemType
} from '@platform/ui-library';
import { FC, ReactNode } from 'react';

export type ToolbarDropdownItem = Omit<EllipsisMenuItemType, 'label'> & {
  /** EllipsisMenu types label as string but renders it as a ReactNode child. */
  label: ReactNode;
};

export type ToolbarDropdownProps = {
  /** Label content shown on the toolbar trigger button. */
  children: ReactNode;
  className?: string;
  items: ToolbarDropdownItem[];
};

/**
 * Portaled toolbar select built on EllipsisMenu.
 * Trigger is a small/outline Button with a trailing chevron — escapes overflow:hidden ancestors.
 */
export const ToolbarDropdown: FC<ToolbarDropdownProps> = ({
  children,
  className,
  items
}) => {
  if (!items?.length) {
    return null;
  }

  return (
    <EllipsisMenu items={items as EllipsisMenuItemType[]}>
      <Button
        className={className}
        color={{
          background: 'transparent',
          border: 'color-mix(in oklab, var(--theme-accent) 50%, transparent)',
          text: 'currentColor'
        }}
        icon={ChevronDownIcon}
        iconPosition="after"
        theme={['small', 'color']}
        type="button"
      >
        {children}
      </Button>
    </EllipsisMenu>
  );
};
